class FlexibleSkeleton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this._loading = true;
    this._error = false;
  }

  static get observedAttributes() {
    return ["loading", "error"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (name === "loading") {
      this._loading = newValue !== "false" && newValue !== null;
    }
    if (name === "error") {
      this._error = newValue !== "false" && newValue !== null;
    }
    this.updateState();
  }

  connectedCallback() {
    this.render();
    this.updateState();
  }

  render() {
    this.shadowRoot.innerHTML = `
    <style>
      :host { display: block; }

      /* Default fallback style blocks - hidden state */
      slot[name="loading"], slot[name="content"], slot[name="error"] {
        display: none !important;
      }

      /* --- THE STATE SWAP ENGINE --- */
      :host([error]) slot[name="error"] { display: block !important; }
      :host([loading]:not([error])) slot[name="loading"] { display: block !important; }
      :host(:not([loading]):not([error])) slot[name="content"] { display: block !important; }
    </style>
    
    <slot name="loading"></slot>
    <slot name="content"></slot>
    <slot name="error"></slot>
  `;
  }

  updateState() {
    if (this._error) {
      this.setAttribute("error", "");
    } else {
      this.removeAttribute("error");
    }

    if (this._loading) {
      this.setAttribute("loading", "");
    } else {
      this.removeAttribute("loading");
    }
  }
}
customElements.define("custom-skeleton", FlexibleSkeleton);
